/* ══════════════════════════════════════════════════════════
   LOOPBACK LIFESTYLE — THEME JS
   Fonts: Barlow + DM Mono  |  Colors: Navy/Fluoro
══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── DARK / LIGHT MODE ── */
  const THEME_KEY = 'loopback-theme';

  function getTheme() {
    return localStorage.getItem(THEME_KEY) || 'light';
  }

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
  }

  window.toggleTheme = function () {
    applyTheme(getTheme() === 'dark' ? 'light' : 'dark');
  };

  applyTheme(getTheme());

  /* ── FOCUS TRAP HELPER ── */
  function trapFocus(container, e) {
    var focusable = Array.from(container.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return !el.closest('[hidden]') && !el.closest('[aria-hidden="true"]'); });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ── MOBILE MENU ── */
  const hamburger = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  if (hamburger && mobileMenu) {
    function openMobileMenu() {
      mobileMenu.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = mobileMenu.querySelector('a[href],button:not([disabled])');
      if (first) first.focus();
      document.addEventListener('keydown', mobileMenuKey);
    }
    function closeMobileMenu() {
      mobileMenu.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      hamburger.focus();
      document.removeEventListener('keydown', mobileMenuKey);
    }
    function mobileMenuKey(e) {
      if (e.key === 'Escape') { closeMobileMenu(); return; }
      if (e.key === 'Tab') trapFocus(mobileMenu, e);
    }
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.contains('open') ? closeMobileMenu() : openMobileMenu();
    });
    document.addEventListener('click', function (e) {
      if (mobileMenu.classList.contains('open') &&
          !hamburger.contains(e.target) &&
          !mobileMenu.contains(e.target)) {
        closeMobileMenu();
      }
    });
  }

  /* ── NAV CATEGORIES DROPDOWN ── */
  const catBtn = document.getElementById('nav-categories-btn');
  const catDrop = document.getElementById('nav-categories-dropdown');

  if (catBtn && catDrop) {
    function openCat() {
      catDrop.hidden = false;
      catBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', closeCatOutside);
      document.addEventListener('keydown', closeCatKey);
    }
    function closeCat() {
      catDrop.hidden = true;
      catBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', closeCatOutside);
      document.removeEventListener('keydown', closeCatKey);
    }
    function closeCatOutside(e) {
      if (!catBtn.contains(e.target) && !catDrop.contains(e.target)) closeCat();
    }
    function closeCatKey(e) {
      if (e.key === 'Escape') { closeCat(); catBtn.focus(); }
    }
    catBtn.addEventListener('click', function () {
      catDrop.hidden ? openCat() : closeCat();
    });
  }

  /* ── NAV SHOP DROPDOWN ── */
  const shopBtn = document.getElementById('nav-shop-btn');
  const shopDrop = document.getElementById('nav-shop-dropdown');

  if (shopBtn && shopDrop) {
    function openShop() {
      shopDrop.hidden = false;
      shopBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', closeShopOutside);
      document.addEventListener('keydown', closeShopKey);
    }
    function closeShop() {
      shopDrop.hidden = true;
      shopBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', closeShopOutside);
      document.removeEventListener('keydown', closeShopKey);
    }
    function closeShopOutside(e) {
      if (!shopBtn.contains(e.target) && !shopDrop.contains(e.target)) closeShop();
    }
    function closeShopKey(e) {
      if (e.key === 'Escape') { closeShop(); shopBtn.focus(); }
    }
    shopBtn.addEventListener('click', function () {
      shopDrop.hidden ? openShop() : closeShop();
    });
  }

  /* ── NAV COLLECTIONS DROPDOWN ── */
  const collsBtn = document.getElementById('nav-collections-btn');
  const collsDrop = document.getElementById('nav-collections-dropdown');

  if (collsBtn && collsDrop) {
    const collsUrl = collsBtn.dataset.collectionsUrl || '/collections';

    function openCollections() {
      collsDrop.hidden = false;
      collsBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', closeCollsOutside);
      document.addEventListener('keydown', closeCollsKey);
    }
    function closeCollections() {
      collsDrop.hidden = true;
      collsBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', closeCollsOutside);
      document.removeEventListener('keydown', closeCollsKey);
    }
    function closeCollsOutside(e) {
      if (!collsBtn.contains(e.target) && !collsDrop.contains(e.target)) closeCollections();
    }
    function closeCollsKey(e) {
      if (e.key === 'Escape') { closeCollections(); collsBtn.focus(); }
    }
    collsBtn.addEventListener('click', function () {
      if (collsDrop.hidden) {
        openCollections();
      } else {
        window.location.href = collsUrl;
      }
    });
  }

  /* ── SEARCH OVERLAY ── */
  const searchToggle = document.getElementById('search-toggle');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.getElementById('search-close');
  const searchBackdrop = document.getElementById('search-backdrop');
  const searchInput = document.getElementById('search-input');

  if (searchToggle && searchOverlay) {
    function openSearch() {
      searchOverlay.classList.add('open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchInput.focus();
    }
    function closeSearch() {
      searchOverlay.classList.remove('open');
      searchOverlay.setAttribute('aria-hidden', 'true');
    }
    searchToggle.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('open')) closeSearch();
    });
  }

  /* ── QUICK ADD TO CART ── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.btn-quick-add[data-variant-id]');
    if (!btn || btn.disabled) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const original = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added';
        updateCartCount();
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = original; }, 2000);
      });
  });

  /* ── PRODUCT CARD HOVER PANEL ── */
  /* CSS @media(hover:hover) .product-card:hover .card-hover-panel handles show/hide */
  (function () {
    /* click delegation: color / size / atc */
    document.addEventListener('click', function (e) {
      var colorBtn = e.target.closest('.chp-color');
      var sizeBtn  = e.target.closest('.chp-size');
      var atcBtn   = e.target.closest('.chp-atc');
      if (!colorBtn && !sizeBtn && !atcBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var panel = (colorBtn || sizeBtn || atcBtn).closest('.card-hover-panel');
      if (!panel) return;
      var variants = JSON.parse(panel.dataset.variants || '[]');

      if (colorBtn) {
        panel.querySelectorAll('.chp-color').forEach(function (b) { b.classList.remove('is-sel'); });
        colorBtn.classList.add('is-sel');
        var color = colorBtn.dataset.value;
        var card = colorBtn.closest('.product-card');
        var colorVariant = variants.find(function (v) {
          return [v.option1, v.option2, v.option3].indexOf(color) !== -1 && v.featured_image;
        });
        if (colorVariant && card) {
          var img = card.querySelector('.product-card__img');
          if (img) img.src = colorVariant.featured_image.src;
        }
        panel.querySelectorAll('.chp-size').forEach(function (sBtn) {
          var size = sBtn.dataset.value;
          var avail = variants.some(function (v) {
            var opts = [v.option1, v.option2, v.option3].filter(Boolean);
            return opts.indexOf(color) !== -1 && opts.indexOf(size) !== -1 && v.available;
          });
          sBtn.disabled = !avail;
          sBtn.setAttribute('aria-disabled', avail ? 'false' : 'true');
          sBtn.classList.toggle('is-out', !avail);
          if (!avail && sBtn.classList.contains('is-sel')) {
            sBtn.classList.remove('is-sel');
            var firstAvail = panel.querySelector('.chp-size:not([disabled])');
            if (firstAvail) firstAvail.classList.add('is-sel');
          }
        });
        return;
      }

      if (sizeBtn) {
        if (sizeBtn.disabled) return;
        panel.querySelectorAll('.chp-size').forEach(function (b) { b.classList.remove('is-sel'); });
        sizeBtn.classList.add('is-sel');
        return;
      }

      if (atcBtn) {
        if (atcBtn.disabled) return;
        var selColorBtn = panel.querySelector('.chp-color.is-sel');
        var selSizeBtn  = panel.querySelector('.chp-size.is-sel');
        var colorVal = selColorBtn ? selColorBtn.dataset.value : null;
        var sizeVal  = selSizeBtn  ? selSizeBtn.dataset.value  : null;
        var match = variants.find(function (v) {
          var opts = [v.option1, v.option2, v.option3].filter(Boolean);
          if (colorVal && opts.indexOf(colorVal) === -1) return false;
          if (sizeVal  && opts.indexOf(sizeVal)  === -1) return false;
          return v.available;
        });
        if (!match && colorVal) {
          match = variants.find(function (v) {
            return [v.option1, v.option2, v.option3].indexOf(colorVal) !== -1 && v.available;
          });
        }
        if (!match) match = variants.find(function (v) { return v.available; });
        if (!match) return;
        var origHtml = atcBtn.innerHTML;
        atcBtn.disabled = true;
        atcBtn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: match.id, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            atcBtn.textContent = '✓ ADDED';
            updateCartCount();
            setTimeout(function () { atcBtn.innerHTML = origHtml; atcBtn.disabled = false; }, 2000);
          })
          .catch(function () { atcBtn.innerHTML = origHtml; atcBtn.disabled = false; });
      }
    });
  }());

  /* ── PRODUCT FORM (PDP) ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const submitBtn = productForm.querySelector('[type="submit"]');
      const mobBtn = document.getElementById('mob-bar-atc-btn');
      const original = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding...'; submitBtn.disabled = true; }
      if (mobBtn) { mobBtn.textContent = 'Adding...'; mobBtn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'Error'); });
          return r.json();
        })
        .then(function () {
          if (submitBtn) submitBtn.textContent = '✓ Added to cart';
          if (mobBtn) mobBtn.textContent = '✓ Added';
          updateCartCount();
          showCartPopup();
          setTimeout(function () {
            if (submitBtn) { submitBtn.textContent = original; submitBtn.disabled = false; }
            if (mobBtn) { mobBtn.innerHTML = '&#9658; ADD TO CART'; mobBtn.disabled = false; }
          }, 2500);
        })
        .catch(function (err) {
          var msg = (err && err.message) ? err.message : 'Error — try again';
          if (submitBtn) { submitBtn.textContent = msg; submitBtn.disabled = false; }
          if (mobBtn) { mobBtn.textContent = msg; mobBtn.disabled = false; }
          setTimeout(function () {
            if (submitBtn) submitBtn.textContent = original;
            if (mobBtn) mobBtn.innerHTML = '&#9658; ADD TO CART';
          }, 2500);
        });
    });
  }

  /* ── CART ADDED POPUP ── */
  var cartPopupTimer = null;

  window.showCartPopup = function () {
    var popup = document.getElementById('cart-popup');
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('visible');
    clearTimeout(cartPopupTimer);
    cartPopupTimer = setTimeout(window.closeCartPopup, 2000);
  };

  window.closeCartPopup = function () {
    var popup = document.getElementById('cart-popup');
    if (!popup) return;
    popup.classList.remove('visible');
    popup.setAttribute('aria-hidden', 'true');
    clearTimeout(cartPopupTimer);
  };

  /* ── CART COUNT ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('#cart-count, .nav-cart-count');
        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  /* ── PDP: IMAGE SWITCHER ── */
  window.switchImage = function (btn) {
    document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
    var url = btn.dataset.imageUrl;
    var mainImg = document.getElementById('main-product-img');
    var mainWrap = document.getElementById('pdp-main-img');
    if (url && mainImg) {
      if (mainWrap) mainWrap.classList.add('is-loading');
      mainImg.addEventListener('load', function () {
        if (mainWrap) mainWrap.classList.remove('is-loading');
      }, { once: true });
      mainImg.addEventListener('error', function () {
        if (mainWrap) mainWrap.classList.remove('is-loading');
      }, { once: true });
      mainImg.src = url;
    }
    var color = btn.dataset.color;
    var optionIdx = parseInt(btn.dataset.colorOption || '0', 10);
    if (color && optionIdx) {
      var colorBtn = Array.from(document.querySelectorAll('.color-opt')).find(function (b) {
        return b.dataset.value === color;
      });
      if (colorBtn) selectOption(colorBtn, optionIdx, color);
    }
  };

  /* ── PDP: IMAGE LIGHTBOX ── */
  (function () {
    var lb = document.getElementById('img-lightbox');
    if (!lb) return;

    var lbImg    = lb.querySelector('.lb-main-img');
    var lbTrack  = lb.querySelector('.lb-thumbs-track');
    var lbPrev   = lb.querySelector('.lb-prev');
    var lbNext   = lb.querySelector('.lb-next');

    function openLightbox() {
      var mainImg = document.getElementById('main-product-img');
      if (!mainImg) return;

      /* populate large image */
      lbImg.src = mainImg.src;
      lbImg.alt = mainImg.alt;

      /* populate thumb strip from page thumbnails */
      lbTrack.innerHTML = '';
      var pageThumbs = document.querySelectorAll('.thumb');
      if (pageThumbs.length > 1) {
        pageThumbs.forEach(function (t) {
          var btn = document.createElement('button');
          btn.className = 'lb-thumb' + (t.classList.contains('active') ? ' active' : '');
          btn.setAttribute('aria-label', t.getAttribute('aria-label') || '');
          var bigUrl = t.dataset.imageUrl || '';
          btn.dataset.imageUrl = bigUrl;
          var tImg = t.querySelector('img');
          if (tImg) {
            var i = document.createElement('img');
            i.src = tImg.src;
            i.alt = tImg.alt;
            i.width = 120; i.height = 120;
            btn.appendChild(i);
          }
          btn.addEventListener('click', function () {
            lbTrack.querySelectorAll('.lb-thumb').forEach(function (x) { x.classList.remove('active'); });
            btn.classList.add('active');
            if (bigUrl) { lbImg.src = bigUrl; lbImg.alt = btn.getAttribute('aria-label'); }
          });
          lbTrack.appendChild(btn);
        });
        lb.querySelector('.lb-thumbs-row').style.display = '';
      } else {
        lb.querySelector('.lb-thumbs-row').style.display = 'none';
      }

      lb.removeAttribute('hidden');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.lb-close').focus();
    }

    window.closeLightbox = function () {
      lb.setAttribute('hidden', '');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    /* open on click of main image */
    var mainImgWrap = document.getElementById('pdp-main-img');
    if (mainImgWrap) {
      mainImgWrap.style.cursor = 'zoom-in';
      mainImgWrap.addEventListener('click', openLightbox);
    }

    /* close on backdrop click */
    lb.addEventListener('click', function (e) {
      if (e.target === lb) window.closeLightbox();
    });

    /* close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hasAttribute('hidden')) window.closeLightbox();
    });

    /* thumb strip scroll buttons */
    if (lbPrev) lbPrev.addEventListener('click', function () { lbTrack.scrollBy({ left: -140, behavior: 'smooth' }); });
    if (lbNext) lbNext.addEventListener('click', function () { lbTrack.scrollBy({ left:  140, behavior: 'smooth' }); });
  }());

  /* ── PDP: OPTION SELECTOR ── */
  /* syncs mob trigger display and popup button states for one option */
  function syncMobOption(optionIndex, value) {
    /* update text trigger value */
    var valEl = document.getElementById('mob-opt-val-' + optionIndex);
    if (valEl) valEl.textContent = value;

    /* update popup label value */
    var popupValEl = document.getElementById('popup-opt-val-' + optionIndex);
    if (popupValEl) popupValEl.textContent = value;

    /* update color dot background */
    var dot = document.getElementById('mob-opt-dot-' + optionIndex);
    if (dot) {
      var popup = document.getElementById('mob-popup-' + optionIndex);
      if (popup) {
        var colorBtn = Array.from(popup.querySelectorAll('.color-opt')).find(function (b) { return b.dataset.value === value; });
        if (colorBtn) dot.style.background = colorBtn.style.background;
      }
    }

    /* sync popup button .selected states */
    var popupEl = document.getElementById('mob-popup-' + optionIndex);
    if (popupEl) {
      popupEl.querySelectorAll('.color-opt, .size-opt').forEach(function (b) { b.classList.remove('selected'); });
      var popupBtn = Array.from(popupEl.querySelectorAll('.color-opt, .size-opt')).find(function (b) { return b.dataset.value === value; });
      if (popupBtn) popupBtn.classList.add('selected');
    }
  }

  window.selectOption = function (btn, optionIdx, value) {
    var group = btn.closest('.size-opts, .color-opts');
    if (group) group.querySelectorAll('button').forEach(function (b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    var labelEl = document.getElementById('option-val-' + optionIdx);
    if (labelEl) labelEl.textContent = value;
    syncMobOption(optionIdx, value);
    updateVariant();
  };

  function updateVariant() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var variantData = window.__productVariants__;
    if (!variantData) return;

    var selected = [];
    document.querySelectorAll('.size-opt.selected, .color-opt.selected').forEach(function (b) {
      selected.push(b.dataset.value);
    });

    var match = variantData.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return selected.every(function (o) { return opts.includes(o); });
    });

    if (match) {
      var hidden = document.getElementById('selected-variant');
      if (hidden) hidden.value = match.id;

      var currency = (window.Shopify && Shopify.currency ? Shopify.currency.active : null)
                     || window.__shopCurrency__ || 'USD';
      var formattedPrice = (match.price / 100).toLocaleString('en-US', {
        style: 'currency', currency: currency
      });
      var priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formattedPrice;
      var stickyPriceEl = document.getElementById('sticky-atc-price');
      if (stickyPriceEl) stickyPriceEl.textContent = formattedPrice;
      var mobPriceEl = document.getElementById('mob-bar-price');
      if (mobPriceEl) mobPriceEl.textContent = formattedPrice;

      /* switch main image to variant's featured image when available */
      if (match.featured_image && match.featured_image.src) {
        var imgSrc = match.featured_image.src;
        var mainImg = document.getElementById('main-product-img');
        var mainWrap = document.getElementById('pdp-main-img');
        if (mainImg) {
          if (mainWrap) mainWrap.classList.add('is-loading');
          mainImg.addEventListener('load', function () {
            if (mainWrap) mainWrap.classList.remove('is-loading');
          }, { once: true });
          mainImg.addEventListener('error', function () {
            if (mainWrap) mainWrap.classList.remove('is-loading');
          }, { once: true });
          mainImg.src = imgSrc;
        }
        /* sync active thumb if a matching thumbnail exists */
        var thumbs = document.querySelectorAll('.thumb');
        thumbs.forEach(function (t) {
          t.classList.remove('active');
          if (t.dataset.imageUrl && t.dataset.imageUrl.split('?')[0] === imgSrc.split('?')[0]) {
            t.classList.add('active');
          }
        });
      }
    }
  }
  window.updateVariant = updateVariant;

  /* ── PDP: MOBILE FLOATING BAR ── */
  window.mobSelectOption = function (sel) {
    var optionIdx = parseInt(sel.dataset.optionIndex, 10);
    var value = sel.value;
    /* sync desktop button selected state */
    var selectors = document.querySelectorAll('.option-selector');
    var group = selectors[optionIdx - 1];
    if (group) {
      group.querySelectorAll('button').forEach(function (b) { b.classList.remove('selected'); });
      var match = Array.from(group.querySelectorAll('button')).find(function (b) { return b.dataset.value === value; });
      if (match) match.classList.add('selected');
    }
    var labelEl = document.getElementById('option-val-' + optionIdx);
    if (labelEl) labelEl.textContent = value;
    updateVariant();
  };

  window.mobAddToCart = function () {
    var form = document.getElementById('product-form');
    if (!form) return;
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  };

  window.openMobPopup = function (optionIndex) {
    document.querySelectorAll('.mob-opt-popup').forEach(function (p) { p.setAttribute('hidden', ''); });
    var popup = document.getElementById('mob-popup-' + optionIndex);
    if (popup) popup.removeAttribute('hidden');
  };

  window.closeMobPopup = function (optionIndex) {
    var popup = document.getElementById('mob-popup-' + optionIndex);
    if (popup) popup.setAttribute('hidden', '');
  };

  window.mobPopupSelect = function (optionIndex, value) {
    /* sync desktop buttons + label */
    var selectors = document.querySelectorAll('.option-selector');
    var group = selectors[optionIndex - 1];
    if (group) {
      group.querySelectorAll('button').forEach(function (b) { b.classList.remove('selected'); });
      var desktopBtn = Array.from(group.querySelectorAll('button')).find(function (b) { return b.dataset.value === value; });
      if (desktopBtn) desktopBtn.classList.add('selected');
    }
    var labelEl = document.getElementById('option-val-' + optionIndex);
    if (labelEl) labelEl.textContent = value;

    /* sync mob trigger display + popup button states */
    syncMobOption(optionIndex, value);

    updateVariant();
    window.closeMobPopup(optionIndex);
  };

  /* ── PDP: TABS ── */
  document.querySelectorAll('[role="tab"]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('[role="tab"]').forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = true; });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
    });
  });

  /* ── STICKY ATC BAR (desktop: mob-atc-bar slides in) ── */
  var mobAtcBar = document.getElementById('mob-atc-bar');
  var mainAtcBtn = document.querySelector('.btn-atc');

  if (mobAtcBar && mainAtcBtn) {
    /* on desktop: show/hide mob-atc-bar based on main ATC visibility */
    /* on mobile: CSS overrides transform so bar is always visible     */
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          mobAtcBar.classList.remove('visible');
          mobAtcBar.setAttribute('aria-hidden', 'true');
        } else {
          mobAtcBar.classList.add('visible');
          mobAtcBar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0.5 });

    atcObserver.observe(mainAtcBtn);
  }

  /* ── PDP FLOATING IMAGE THUMB ── */
  (function () {
    var mainImgWrap = document.getElementById('pdp-main-img');
    var floatThumb  = document.getElementById('pdp-float-thumb');
    var mainImg     = document.getElementById('main-product-img');
    var floatImg    = document.getElementById('pdp-float-img');
    if (!mainImgWrap || !floatThumb || !mainImg || !floatImg) return;

    floatImg.src = mainImg.src;
    new MutationObserver(function () { floatImg.src = mainImg.src; })
      .observe(mainImg, { attributes: true, attributeFilter: ['src'] });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var aboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        floatThumb.classList.toggle('visible', aboveViewport);
      });
    }, { threshold: 0 }).observe(mainImgWrap);
  }());

  /* ── SMOOTH SCROLL ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  /* ── CART QUANTITY STEPPER ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-stepper-btn[data-stepper-action]');
    if (!btn) return;
    var input = btn.closest('.cart-item__stepper').querySelector('.cart-item__qty');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    if (btn.dataset.stepperAction === 'inc') input.value = Math.min(val + 1, 10);
    if (btn.dataset.stepperAction === 'dec') input.value = Math.max(val - 1, 0);
  });

  /* ── RECOMMENDED PRODUCTS (Shopify Recommendations API) ── */
  (function () {

    /* ── Image picker — mirrors Liquid coll-card / product-card logic ── */
    function pickRecsImage(product, imgMode, mockupPick, mockupIndex, frontPick, frontColor, otherMatch) {
      var images   = product.images   || [];
      var variants = product.variants || [];
      if (!images.length) return null;

      function fname(src) { return (src || '').split('/').pop().split('?')[0].toLowerCase(); }

      if (imgMode === 'mockup') {
        /* build set of IDs linked to any variant */
        var varIds = {};
        variants.forEach(function (v) { if (v.featured_image) varIds[v.featured_image.id] = true; });
        var unlinked = images.filter(function (img) { return !varIds[img.id]; });

        if (mockupPick === 'index') {
          return unlinked[mockupIndex - 1] || images[0];
        } else {
          return unlinked.length
            ? unlinked[Math.floor(Math.random() * unlinked.length)]
            : images[0];
        }

      } else if (imgMode === 'front') {
        var frontPool = images.filter(function (img) {
          var alt  = (img.alt || '').toLowerCase();
          return alt.indexOf('front') !== -1 || fname(img.src).indexOf('front') !== -1;
        });
        if (frontPick === 'color') {
          var kw = (frontColor || '').toLowerCase().trim();
          var hit = null;
          for (var fi = 0; fi < frontPool.length; fi++) {
            var fa = (frontPool[fi].alt || '').toLowerCase();
            if (fa.indexOf(kw) !== -1 || fname(frontPool[fi].src).indexOf(kw) !== -1) {
              hit = frontPool[fi]; break;
            }
          }
          return hit || images[0];
        } else {
          return frontPool.length
            ? frontPool[Math.floor(Math.random() * frontPool.length)]
            : images[0];
        }

      } else if (imgMode === 'other') {
        var kw2 = (otherMatch || '').toLowerCase().trim();
        if (kw2) {
          for (var oi = 0; oi < images.length; oi++) {
            var oa = (images[oi].alt || '').toLowerCase();
            if (oa.indexOf(kw2) !== -1 || fname(images[oi].src).indexOf(kw2) !== -1) return images[oi];
          }
        }
      }

      return images[0]; /* default */
    }

    /* ── Normalise tags — API may return array or comma string ── */
    function productHasTag(p, tag) {
      if (!p.tags) return false;
      if (Array.isArray(p.tags)) return p.tags.map(function (t) { return t.toLowerCase(); }).indexOf(tag.toLowerCase()) !== -1;
      return (',' + String(p.tags).toLowerCase().replace(/\s*,\s*/g, ',') + ',').indexOf(',' + tag.toLowerCase() + ',') !== -1;
    }

    var containers = document.querySelectorAll('[data-product-id][data-limit]');
    containers.forEach(function (container) {
      var productId = container.dataset.productId;
      var limit     = parseInt(container.dataset.limit, 10) || 4;
      var grid      = container.querySelector('.product-grid, .recs-grid, .cart-recs__grid');
      if (!grid || !productId) return;

      /* image settings */
      var imgMode    = container.dataset.imgMode    || 'default';
      var mockupPick = container.dataset.mockupPick || 'random';
      var mockupIndex = parseInt(container.dataset.mockupIndex, 10) || 1;
      var frontPick  = container.dataset.frontPick  || 'random';
      var frontColor = container.dataset.frontColor || 'black';
      var otherMatch = container.dataset.otherMatch || '';

      /* sex filter */
      var filterSex    = container.dataset.filterSex === 'true';
      var sexTagMens   = container.dataset.sexTagMens   || 'mens';
      var sexTagWomens = container.dataset.sexTagWomens || 'womens';
      var rawTags      = container.dataset.productTags  || '';
      var productTagsList = rawTags ? rawTags.split(',').map(function (t) { return t.trim(); }) : [];
      var productSex   = '';
      if (productTagsList.indexOf(sexTagMens) !== -1)   productSex = sexTagMens;
      else if (productTagsList.indexOf(sexTagWomens) !== -1) productSex = sexTagWomens;

      /* over-fetch when sex filtering so trimming still gives enough results */
      var fetchLimit = (filterSex && productSex) ? Math.min(limit * 3, 24) : limit;

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + fetchLimit + '&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) return;

          var products = data.products;

          if (filterSex && productSex) {
            products = products.filter(function (p) { return productHasTag(p, productSex); });
          }

          products = products.slice(0, limit);
          if (!products.length) return;

          var currency = (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : null)
                        || window.__shopCurrency__ || 'USD';

          var html = products.map(function (p) {
            var price   = formatMoney(p.price_min, currency);
            var compare = p.compare_at_price_min && p.compare_at_price_min > p.price_min
              ? formatMoney(p.compare_at_price_min, currency) : null;

            var pickedImg = pickRecsImage(p, imgMode, mockupPick, mockupIndex, frontPick, frontColor, otherMatch);
            var imgSrc    = pickedImg ? (pickedImg.src.split('?')[0] + '?width=600') : '';
            var imgAlt    = pickedImg ? esc(pickedImg.alt || p.title) : esc(p.title);
            var imgTag    = imgSrc
              ? '<img src="' + imgSrc + '" alt="' + imgAlt + '" class="product-card__img" loading="lazy" width="600" height="600">'
              : '<div class="product-card__placeholder"></div>';

            var availVariant = p.variants && p.variants.find(function (v) { return v.available; });
            var variantId    = availVariant ? availVariant.id : (p.variants && p.variants[0] ? p.variants[0].id : '');
            return '<div class="product-card">'
              + '<a href="/products/' + p.handle + '" class="product-card__link" aria-label="' + esc(p.title) + '">'
              + '<div class="product-card__img-wrap">' + imgTag + '</div>'
              + '<div class="product-card__info">'
              + '<h3 class="product-card__name">' + esc(p.title) + '</h3>'
              + '<div class="product-card__footer">'
              + '<div class="product-card__price"><span class="price-current">' + price + '</span>'
              + (compare ? '<span class="price-was">' + compare + '</span>' : '') + '</div>'
              + (variantId
                ? '<button class="btn-quick-add" data-product-id="' + p.id + '" data-variant-id="' + variantId + '" aria-label="Add ' + esc(p.title) + ' to cart"'
                  + (!availVariant ? ' disabled' : '') + '>'
                  + (availVariant ? '+ Add' : 'Sold out') + '</button>'
                : '')
              + '</div></div></a></div>';
          }).join('');
          grid.innerHTML = html;
        })
        .catch(function () { /* keep server-rendered fallback */ });
    });

    function formatMoney(cents, currency) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
    }
    function esc(s) {
      return String(s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  })();

  /* ── FILTER & SORT BAR ── */
  (function () {
    var fsb = document.querySelector('.fsb');
    if (!fsb) return;

    var pageType    = fsb.dataset.pageType;
    var currentSort = fsb.dataset.currentSort || '';

    var FILTER_KEYS  = ['filter.p.tag', 'filter.p.option.Size', 'filter.p.option.Color'];
    var KEY_LABEL    = { 'filter.p.tag': 'Sex', 'filter.p.option.Size': 'Size', 'filter.p.option.Color': 'Color' };
    var KEY_GROUP    = { 'filter.p.tag': 'sex', 'filter.p.option.Size': 'size', 'filter.p.option.Color': 'color' };

    var params      = new URLSearchParams(window.location.search);
    var collHandle  = fsb.dataset.collectionHandle || '';
    var pathTagMatch = collHandle && window.location.pathname.match(/^\/collections\/[^\/]+\/([^\/]+)$/);
    var activePathTag = pathTagMatch ? decodeURIComponent(pathTagMatch[1]) : '';
    var chipsEl  = document.getElementById('fsbChips');
    var badgeEl  = document.getElementById('fsbBadge');
    var drawerEl = document.getElementById('fsbDrawer');
    var filterBtn = document.getElementById('fsbFilterBtn');

    /* ── Sort ── */
    var sortSelects = document.querySelectorAll('[data-sort-select]');
    var activeSortVal = params.get('sort_by') || currentSort || '';

    sortSelects.forEach(function (sel) {
      if (activeSortVal) sel.value = activeSortVal;
      sel.addEventListener('change', function () {
        var val = this.value;
        if (pageType === 'list-collections') {
          sortListCollections(val);
          var url = new URL(window.location.href);
          if (val) url.searchParams.set('sort_by', val);
          else url.searchParams.delete('sort_by');
          window.history.replaceState({}, '', url.toString());
          /* sync the other select */
          sortSelects.forEach(function (s) { if (s !== sel) s.value = val; });
        } else {
          var url = new URL(window.location.href);
          if (val) url.searchParams.set('sort_by', val);
          else url.searchParams.delete('sort_by');
          url.searchParams.delete('page');
          window.location.href = url.toString();
        }
      });
    });

    /* Client-side sort for list-collections page */
    function sortListCollections(val) {
      var grid = document.querySelector('.collection-card-grid');
      if (!grid) return;
      var cards = Array.from(grid.querySelectorAll('.coll-card'));
      cards.sort(function (a, b) {
        var ta = ((a.querySelector('.coll-card__title') || {}).textContent || '').trim();
        var tb = ((b.querySelector('.coll-card__title') || {}).textContent || '').trim();
        return val === 'title-descending' ? tb.localeCompare(ta) : ta.localeCompare(tb);
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }

    if (pageType === 'list-collections' && activeSortVal) {
      sortListCollections(activeSortVal);
    }

    /* ── Filter option clicks ── */
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.fsb__opt[data-filter-key]');
      if (!opt) return;
      var key   = opt.dataset.filterKey;
      var value = opt.dataset.filterValue;
      var url   = new URL(window.location.href);
      url.searchParams.delete('page');
      if (key === 'filter.p.tag' && collHandle) {
        url.pathname = '/collections/' + collHandle + (value ? '/' + value : '');
        window.location.href = url.toString();
        return;
      }
      var current = url.searchParams.get(key);
      if (!value || current === value) {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
      window.location.href = url.toString();
    });

    /* ── Desktop dropdowns ── */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.fsb__trigger');
      if (trigger) {
        e.stopPropagation();
        var dropdown = trigger.closest('.fsb__dropdown');
        var panel    = dropdown.querySelector('.fsb__panel');
        var wasOpen  = !panel.hidden;
        closeAllDropdowns();
        if (!wasOpen) {
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!e.target.closest('.fsb__dropdown')) closeAllDropdowns();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns();
    });

    function closeAllDropdowns() {
      document.querySelectorAll('.fsb__panel').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('.fsb__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }

    /* ── Active state on load ── */
    var activeCount = 0;
    FILTER_KEYS.forEach(function (key) {
      var value = (key === 'filter.p.tag' && collHandle) ? activePathTag : params.get(key);
      if (!value) return;
      activeCount++;
      document.querySelectorAll('.fsb__opt[data-filter-key="' + key + '"]').forEach(function (opt) {
        if (opt.dataset.filterValue === value) opt.classList.add('fsb__opt--active');
      });
      var group = KEY_GROUP[key];
      if (group) {
        document.querySelectorAll('.fsb__trigger[data-filter-group="' + group + '"]').forEach(function (t) {
          t.classList.add('fsb__trigger--active');
        });
      }
    });

    if (badgeEl && activeCount > 0) {
      badgeEl.textContent = String(activeCount);
      badgeEl.hidden = false;
    }

    /* ── Active filter chips ── */
    if (chipsEl && activeCount > 0) {
      var html = '';
      FILTER_KEYS.forEach(function (key) {
        var value = (key === 'filter.p.tag' && collHandle) ? activePathTag : params.get(key);
        if (!value) return;
        var optEl = document.querySelector('.fsb__opt[data-filter-key="' + key + '"][data-filter-value="' + value + '"]');
        var label = (optEl && optEl.dataset.filterLabel) ? optEl.dataset.filterLabel : value;
        html += '<button class="fsb-chip" data-chip-key="' + key + '" data-chip-value="' + value + '">'
              + KEY_LABEL[key] + ': ' + label
              + '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
              + '</button>';
      });
      chipsEl.innerHTML = html;
    }

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.fsb-chip[data-chip-key]');
      if (!chip) return;
      var key = chip.dataset.chipKey;
      var url = new URL(window.location.href);
      if (key === 'filter.p.tag' && collHandle) {
        url.pathname = '/collections/' + collHandle;
      } else {
        url.searchParams.delete(key);
      }
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-filter-clear]')) return;
      var url = new URL(window.location.href);
      FILTER_KEYS.forEach(function (k) {
        if (k === 'filter.p.tag' && collHandle) {
          url.pathname = '/collections/' + collHandle;
        } else {
          url.searchParams.delete(k);
        }
      });
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    /* ── Mobile drawer ── */
    function openDrawer() {
      if (!drawerEl) return;
      drawerEl.setAttribute('aria-hidden', 'false');
      drawerEl.classList.add('fsb-drawer--open');
      if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawerEl.querySelector('button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])');
      if (first) first.focus();
      document.addEventListener('keydown', drawerKeyHandler);
    }
    function closeDrawer() {
      if (!drawerEl) return;
      drawerEl.setAttribute('aria-hidden', 'true');
      drawerEl.classList.remove('fsb-drawer--open');
      if (filterBtn) { filterBtn.setAttribute('aria-expanded', 'false'); filterBtn.focus(); }
      document.body.style.overflow = '';
      document.removeEventListener('keydown', drawerKeyHandler);
    }
    function drawerKeyHandler(e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') trapFocus(drawerEl, e);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open]')) { openDrawer(); return; }
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    });
  })();

  /* ── PRODUCT CARD RANDOM COLOR IMAGES ── */
  (function () {
    var imgs = document.querySelectorAll('img[data-random-images]');
    if (!imgs.length) return;

    var types = window.__cardImgTypes__ || {};
    var enabledTypes = Object.keys(types).filter(function (k) { return types[k]; });

    imgs.forEach(function (img) {
      try {
        var pool = JSON.parse(img.dataset.randomImages);
        if (!pool || pool.length < 2) return;

        if (enabledTypes.length > 0) {
          var filtered = pool.filter(function (item) {
            var t = (item.type || '').toLowerCase();
            var f = (item.file || '').toLowerCase();
            return enabledTypes.some(function (k) {
              return t.indexOf(k) !== -1 || f.indexOf(k) !== -1;
            });
          });
          if (filtered.length > 0) pool = filtered;
        }

        var pick = pool[Math.floor(Math.random() * pool.length)];
        img.src = pick.src;
        img.srcset = pick.src2 + ' 300w, ' + pick.src + ' 600w';
        if (pick.alt) img.alt = pick.alt;
      } catch (e) {}
    });
  })();

  /* ── SECTION CARD RANDOM IMAGE PICK ── */
  /* Used by coll-card and product-card snippets for section-level image mode settings.
     No __cardImgTypes__ filtering — pool is pre-filtered in Liquid. Allows pool of 1. */
  (function () {
    var imgs = document.querySelectorAll('img[data-pick-random]');
    if (!imgs.length) return;
    imgs.forEach(function (img) {
      try {
        var pool = JSON.parse(img.dataset.pickRandom);
        if (!pool || !pool.length) return;
        var pick = pool[Math.floor(Math.random() * pool.length)];
        img.src = pick.src;
        if (pick.src2) img.srcset = pick.src2 + ' 300w, ' + pick.src + ' 600w';
        if (pick.alt) img.alt = pick.alt;
      } catch (e) {}
    });
  })();

  /* ── SABBATH MODE ── */
  (function () {
    if (document.documentElement.dataset.sabbath !== 'active') return;

    var banner = document.getElementById('sabbath-banner');
    if (banner) banner.removeAttribute('hidden');

    var ATC_SELECTORS = [
      '.btn-atc',
      '.mob-bar-atc',
      '#mob-bar-atc-btn',
      '.sticky-atc-btn',
      '#sticky-atc-btn',
      '.btn-quick-add',
      '.chp-atc',
      '.cart-checkout-btn',
      'button[name="update"]',
      '.cart-stepper-btn'
    ].join(',');

    function disableCartButtons() {
      document.querySelectorAll(ATC_SELECTORS).forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      });
    }

    disableCartButtons();

    /* Catch any buttons injected after initial render (e.g. dynamic quick-add panels) */
    var obs = new MutationObserver(function (mutations) {
      var dirty = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (dirty) disableCartButtons();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  })();

})();
